"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRainbowComponents = require("react-rainbow-components");

var _styled = require("./styled");
/* eslint-disable react/jsx-wrap-multilines */


var ConfirmModal = function ConfirmModal(props) {
  var header = props.header,
      icon = props.icon,
      question = props.question,
      variant = props.variant,
      isOpen = props.isOpen,
      onCancel = props.onCancel,
      onConfirm = props.onConfirm,
      cancelButtonLabel = props.cancelButtonLabel,
      okButtonLabel = props.okButtonLabel;
  return /*#__PURE__*/_react["default"].createElement(_reactRainbowComponents.Modal, {
    isOpen: isOpen,
    onRequestClose: onCancel,
    footer: /*#__PURE__*/_react["default"].createElement(_styled.ButtonsContainer, null, /*#__PURE__*/_react["default"].createElement(_styled.Button, {
      label: cancelButtonLabel,
      variant: "border",
      onClick: onCancel
    }), /*#__PURE__*/_react["default"].createElement(_styled.Button, {
      label: okButtonLabel,
      variant: variant,
      onClick: onConfirm
    }))
  }, /*#__PURE__*/_react["default"].createElement(_styled.Container, {
    direction: "row"
  }, /*#__PURE__*/_react["default"].createElement(_styled.IconContainer, null, icon), /*#__PURE__*/_react["default"].createElement(_styled.Container, {
    direction: "column"
  }, /*#__PURE__*/_react["default"].createElement(_styled.Header, null, header), /*#__PURE__*/_react["default"].createElement(_styled.Question, null, question))));
};

ConfirmModal.propTypes = {
  /** @ignore */
  isOpen: _propTypes["default"].bool,

  /** The modal header. */
  header: _propTypes["default"].string,

  /** The modal prompt. */
  question: _propTypes["default"].string,

  /** The modal icon. */
  icon: _propTypes["default"].node,

  /** The label for OK button. */
  okButtonLabel: _propTypes["default"].string,

  /** The label for Cancel button. */
  cancelButtonLabel: _propTypes["default"].string,

  /** The modal variant. */
  variant: _propTypes["default"].oneOf(['brand', 'success', 'warning', 'destructive']),

  /** @ignore */
  onCancel: _propTypes["default"].func,

  /** @ignore */
  onConfirm: _propTypes["default"].func
};
ConfirmModal.defaultProps = {
  isOpen: false,
  header: 'Confirm',
  question: undefined,
  icon: undefined,
  okButtonLabel: 'Ok',
  cancelButtonLabel: 'Cancel',
  variant: 'brand',
  onCancel: undefined,
  onConfirm: undefined
};
var _default = ConfirmModal;
exports["default"] = _default;